import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";

export const AiAnalysis = ({ estId, disabled }) => {
  const [a, setA] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/establishments/${estId}/competitors/analysis`).then((r) => setA(r.data)); }, [estId]);

  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/establishments/${estId}/competitors/analysis`); setA(data); toast.success("Analyse générée à partir des données mesurées"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const r = a?.analysis;
  return (
    <div className="bg-white rounded-2xl border border-indigo-100 p-5" data-testid="ai-analysis-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div><h3 className="font-heading font-semibold flex items-center gap-2"><Sparkles className="w-4 h-4 text-indigo-600" /> Ce que cela signifie pour vous</h3>
          <p className="text-xs text-slate-500 mt-1">L'IA explique uniquement les données mesurées ci-dessus (DONNÉE MESURÉE → ANALYSE → RECOMMANDATION). Elle n'invente ni trafic, ni positions, ni avis.</p></div>
        <Button size="sm" onClick={run} disabled={busy || disabled} data-testid="ai-analysis-button" className="rounded-xl bg-indigo-600 hover:bg-indigo-700">{busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1.5" />}{r ? "Régénérer" : "Expliquer la comparaison"}</Button>
      </div>
      {r && (
        <div className="mt-4 space-y-3 text-sm" data-testid="ai-analysis-result">
          <p className="text-slate-800">{r.summary}</p>
          <div className="grid md:grid-cols-2 gap-3">
            {r.you_better?.length > 0 && <div className="rounded-xl bg-emerald-50 p-3"><div className="text-xs font-semibold text-emerald-700 mb-1">Vos points forts mesurés</div><ul className="list-disc pl-4 space-y-0.5 text-emerald-900">{r.you_better.map((x, i) => <li key={i}>{x}</li>)}</ul></div>}
            {r.they_better?.length > 0 && <div className="rounded-xl bg-orange-50 p-3"><div className="text-xs font-semibold text-orange-700 mb-1">Où vos concurrents font mieux</div><ul className="list-disc pl-4 space-y-0.5 text-orange-900">{r.they_better.map((x, i) => <li key={i}>{x}</li>)}</ul></div>}
          </div>
          {r.priority_action && <div className="rounded-xl bg-blue-600 text-white p-4" data-testid="ai-priority-action"><div className="text-[11px] uppercase tracking-wide text-white/70">Action prioritaire</div><div className="font-semibold mt-0.5">{r.priority_action.title}</div><div className="text-sm text-white/80 mt-1">{r.priority_action.why}</div></div>}
          {r.data_gaps?.length > 0 && <p className="text-xs text-slate-400">Données non disponibles : {r.data_gaps.join(" · ")}</p>}
          <p className="text-[11px] text-slate-400">Généré le {new Date(a.created_at).toLocaleString("fr-FR")} · base : {a.based_on?.competitors?.join(", ")}</p>
        </div>
      )}
    </div>
  );
};
